// This is a self-contained script for infinite scroll.
const initInfiniteScroll = () => {
  const pagination = document.querySelector('.pagination-infinite');
  if (!pagination) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const url = pagination.dataset.url;
        if (!url || pagination.classList.contains('loading')) return;

        pagination.classList.add('loading');

        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newGrid = html.getElementById('product-grid');
            const newPagination = html.querySelector('.pagination-infinite');

            if (newGrid && newGrid.children.length > 0) {
              document.getElementById('product-grid').append(...newGrid.children);
            }

            if (newPagination && newPagination.dataset.url) {
              pagination.dataset.url = newPagination.dataset.url;
              pagination.classList.remove('loading');
            } else {
              pagination.remove();
              observer.disconnect();
            }
          }).catch(e => {
            console.error(e);
            pagination.remove();
            observer.disconnect();
          });
      }
    });
  }, {
    rootMargin: '0px 0px 400px 0px' // Load 400px before it's visible
  });

  observer.observe(pagination);
};

// Run on initial page load
document.addEventListener('DOMContentLoaded', initInfiniteScroll);
// Run after filters are used (Shopify's event for section updates)
document.addEventListener('shopify:section:load', () => {
    // We need to re-initialize because filtering replaces the product grid
    initInfiniteScroll();
});
